export const WARNING_SEVERITY = 'warning';
export const ERROR_SEVERITY = 'error';
